import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBodyScrollLock } from 'shared/hooks/useBodyScrollLock';
import { useStoreSelector } from 'store/hooks/storeHooks';

const ALLOWED_PATHS = new Set([
  '/blackfriday/trivia/[gameId]',
  '/blackfriday/trivia/[gameId]/lobby',
  '/ja-jp/blackfriday/trivia/[gameId]',
  '/ja-jp/blackfriday/trivia/[gameId]/lobby',
  '/zh-cn/blackfriday/trivia/[gameId]',
  '/zh-cn/blackfriday/trivia/[gameId]/lobby',
]);

export const AudioLayout = ({ children }) => {
  const { pathname } = useRouter();
  const { t } = useTranslation('trivia');

  const [isMuted, setIsMuted] = useState<any>(false);

  const { audioSource, isAudioPlaying, isAudioControlVisible } = useStoreSelector(
    (state) => state.pageLayout,
  );
  const audi = useRef<HTMLAudioElement>(null);
  const buttonRef = useRef(null);

  useBodyScrollLock(isAudioControlVisible, buttonRef);

  const handleClick = () => {
    if (audi.current) {
      if (isMuted === true) {
        void audi.current.play();
        setIsMuted(false);
      } else {
        void audi.current.pause();
        setIsMuted(true);
      }
    }
  };

  useEffect(() => {
    if (audi.current && isAudioPlaying) {
      void audi.current.play();
    }
    if (audi.current && !isAudioPlaying) {
      void audi.current.pause();
    }
  }, [isAudioPlaying, audioSource, audi]);

  useEffect(() => {
    if (audioSource && !audi.current && ALLOWED_PATHS.has(pathname)) {
      audi.current = new Audio(audioSource);
      audi.current.preload = 'auto';
      audi.current.loop = true;
      void audi.current.play();
    }
  }, [audioSource, audi, pathname]);

  return (
    <>
      {children}
      {ALLOWED_PATHS.has(pathname) && audioSource && isAudioControlVisible && (
        <>
          <button
            ref={buttonRef}
            onClick={handleClick}
            type="button"
            data-qa="audio_button"
            className="audio-mute-button audio-button-unmute"
          >
            {isMuted ? t('trivia.audio.unmute', 'unmute') : t('trivia.audio.mute', 'mute')}
          </button>
        </>
      )}
    </>
  );
};
